var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map((p=>{return+p==p?+p:p}))},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	44914: () => (loadSingletonVersion("default", "react", false, [1,18,2,0], () => (__webpack_require__.e("node_modules_react_index_js").then(() => (() => (__webpack_require__(65043))))))),
	93609: () => (loadSingletonVersion("default", "@emotion/react", false, [1,11,11,1], () => (Promise.all([__webpack_require__.e("vendors-node_modules_emotion_cache_dist_emotion-cache_browser_esm_js"), __webpack_require__.e("node_modules_emotion_react_dist_emotion-react_browser_esm_js-_efab1")]).then(() => (() => (__webpack_require__(57058))))))),
	34118: () => (loadSingletonVersion("default", "@emotion/styled", false, [1,11,11,0], () => (__webpack_require__.e("node_modules_emotion_styled_dist_emotion-styled_browser_esm_js-_b4621").then(() => (() => (__webpack_require__(45903))))))),
	86672: () => (loadSingletonVersion("default", "react-dom", false, [1,18,2,0], () => (__webpack_require__.e("vendors-node_modules_react-dom_index_js").then(() => (() => (__webpack_require__(97950))))))),
	66882: () => (loadSingletonVersion("default", "@mui/material", false, [1,5,14,1], () => (Promise.all([__webpack_require__.e("vendors-node_modules_mui_material_ButtonBase_ButtonBase_js-node_modules_mui_material_Paper_Pa-1ba0c0"), __webpack_require__.e("vendors-node_modules_mui_material_Autocomplete_Autocomplete_js-node_modules_mui_material_Butt-b6d4c5"), __webpack_require__.e("vendors-node_modules_mui_material_SvgIcon_index_js-node_modules_mui_material_colors_index_js--722604"), __webpack_require__.e("vendors-node_modules_mui_material_Modal_Modal_js"), __webpack_require__.e("vendors-node_modules_mui_material_Badge_Badge_js-node_modules_mui_material_Box_Box_js-node_mo-b346a0"), __webpack_require__.e("vendors-node_modules_mui_material_Alert_Alert_js-node_modules_mui_material_AlertTitle_AlertTi-c28da7"), __webpack_require__.e("vendors-node_modules_mui_material_index_js"), __webpack_require__.e("webpack_sharing_consume_default_react-dom_react-dom")]).then(() => (() => (__webpack_require__(27609))))))),
	79498: () => (loadSingletonVersion("default", "@mui/lab", false, [1,5,0,0,,"alpha",137], () => (Promise.all([__webpack_require__.e("vendors-node_modules_mui_material_ButtonBase_ButtonBase_js-node_modules_mui_material_Paper_Pa-1ba0c0"), __webpack_require__.e("vendors-node_modules_mui_material_Autocomplete_Autocomplete_js-node_modules_mui_material_Butt-b6d4c5"), __webpack_require__.e("vendors-node_modules_mui_material_Alert_Alert_js-node_modules_mui_material_AlertTitle_AlertTi-c28da7"), __webpack_require__.e("vendors-node_modules_mui_lab_index_js"), __webpack_require__.e("webpack_sharing_consume_default_react-dom_react-dom")]).then(() => (() => (__webpack_require__(41329))))))),
	15076: () => (loadSingletonVersion("default", "@pagopa/mui-italia", false, [1,1,6,1], () => (Promise.all([__webpack_require__.e("vendors-node_modules_pagopa_mui-italia_dist_index_js"), __webpack_require__.e("webpack_sharing_consume_default_mui_lab_mui_lab")]).then(() => (() => (__webpack_require__(27870))))))),
	41483: () => (loadSingletonVersion("default", "@mui/x-data-grid", false, [1,5,0,1], () => (Promise.all([__webpack_require__.e("vendors-node_modules_mui_material_Autocomplete_Autocomplete_js-node_modules_mui_material_Butt-b6d4c5"), __webpack_require__.e("vendors-node_modules_mui_material_Badge_Badge_js-node_modules_mui_material_Box_Box_js-node_mo-b346a0"), __webpack_require__.e("vendors-node_modules_mui_x-data-grid_index_js")]).then(() => (() => (__webpack_require__(43882))))))),
	71039: () => (loadSingletonVersion("default", "mixpanel-browser", false, [1,2,43,0], () => (__webpack_require__.e("vendors-node_modules_mixpanel-browser_dist_mixpanel_module_js").then(() => (() => (__webpack_require__(52936))))))),
	25125: () => (loadSingletonVersion("default", "@pagopa/mui-italia", false, [1,1,6,1], () => (Promise.all([__webpack_require__.e("vendors-node_modules_pagopa_selfcare-common-frontend_node_modules_pagopa_mui-italia_dist_index_js"), __webpack_require__.e("webpack_sharing_consume_default_mui_lab_mui_lab")]).then(() => (() => (__webpack_require__(40349))))))),
	44704: () => (loadSingletonVersion("default", "@mui/icons-material", false, [1,5,14,1], () => (__webpack_require__.e("vendors-node_modules_mui_icons-material_esm_index_js").then(() => (() => (__webpack_require__(15061))))))),
	74551: () => (loadSingletonVersion("default", "i18next", false, [1,23,7,11], () => (__webpack_require__.e("vendors-node_modules_i18next_dist_esm_i18next_js").then(() => (() => (__webpack_require__(44978))))))),
	39141: () => (loadSingletonVersion("default", "@pagopa/ts-commons", false, [1,13,1,2], () => (Promise.all([__webpack_require__.e("vendors-node_modules_pagopa_selfcare-common-frontend_node_modules_pagopa_ts-commons_lib_index_js"), __webpack_require__.e("_4f7e1")]).then(() => (() => (__webpack_require__(84896))))))),
	53736: () => (loadSingletonVersion("default", "react-i18next", false, [1,15,1,2], () => (__webpack_require__.e("vendors-node_modules_react-i18next_dist_es_index_js").then(() => (() => (__webpack_require__(74117))))))),
	88597: () => (loadSingletonVersion("default", "react-redux", false, [1,7,2,6], () => (__webpack_require__.e("vendors-node_modules_react-redux_es_index_js").then(() => (() => (__webpack_require__(97508))))))),
	44258: () => (loadSingletonVersion("default", "react-router-dom", false, [1,5,2,0], () => (__webpack_require__.e("node_modules_react-router-dom_esm_react-router-dom_js-_80161").then(() => (() => (__webpack_require__(62582)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"webpack_sharing_consume_default_react_react": [
		44914
	],
	"webpack_sharing_consume_default_emotion_react_emotion_react": [
		93609
	],
	"webpack_sharing_consume_default_emotion_styled_emotion_styled": [
		34118
	],
	"webpack_sharing_consume_default_react-dom_react-dom": [
		86672
	],
	"webpack_sharing_consume_default_mui_material_mui_material": [
		66882
	],
	"webpack_sharing_consume_default_mui_lab_mui_lab": [
		79498
	],
	"src_pages_dashboardGroupDetail_GroupDetailPage_tsx-src_pages_dashboardGroupEdit_AddGroupPage_-023f53": [
		15076,
		41483,
		71039,
		25125,
		44704,
		74551,
		39141
	],
	"src_remotes_RoutingGroups_tsx-webpack_sharing_consume_default_react-router-dom_react-router-d-b31539": [
		66882,
		53736,
		88597,
		44258
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}